import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { ArrowVectorRight } from 'src/components/icons/ArrowVectorRight'
import Link from 'src/components/ui/Link'
import useImageDistinguisher from 'src/utils/useImageDistinguisher'

import IndispensabiliDesktop from './components/IndispensabiliDesktop'
import './indispensabili-navigation.scss'

const IndispensabiliNavigation = ({
  desktopBannerWidth,
  banner,
  desktop,
  mobile,
}: IndispensabiliNavigationProps) => {
  const { isMobile } = useBreakpoint()
  const {
    sources,
    desktopTitle,
    desktopText,
    link,
    mobileText,
    mobileTitle,
    text,
    title,
  } = banner

  const { mobileImage, desktopImage } = useImageDistinguisher({ sources })
  const { bannerContent, itemsAlignment, marginTop, marginBottom } = isMobile
    ? mobile
    : desktop

  return (
    <section className="indispensability">
      {isMobile ? (
        <div
          className="indispensability-container"
          style={{
            backgroundImage: `url(${mobileImage})`,
            marginTop: `${marginTop}`,
            marginBottom: `${marginBottom}`,
          }}
        >
          <div className="indispensability-container-heading">
            <h2
              className="indispensability-container-heading__title"
              style={{ textAlign: mobileTitle?.titleAlignment }}
            >
              {title}
            </h2>
            <Link
              className="indispensability-container-heading__link"
              as="a"
              href={link ?? '/'}
              aria-label={text ?? 'Vai alla pagina'}
              style={{ textAlign: mobileText?.textAlignment }}
            >
              {text}
              {text && (
                <ArrowVectorRight
                  className="indispensability-container-heading__icon"
                  width={5}
                  height={8}
                />
              )}
            </Link>
          </div>
          <div
            className="indispensability-container-content"
            style={{ justifyContent: itemsAlignment }}
          >
            {bannerContent.map((item: BannerContentProps, index) => (
              <div
                key={index}
                className="indispensability-container-content-images-container"
              >
                <Link
                  className="indispensability-container-content-images-container"
                  as="a"
                  href={item?.href ?? '/'}
                >
                  <img
                    className="indispensability-container-content-images-container__img"
                    src={item?.src}
                    alt={item?.alt}
                    loading="lazy"
                  />
                  <p
                    className="indispensability-container-content-images-container__text"
                    style={{ color: item?.color ?? '#000000' }}
                  >
                    {item?.text}
                  </p>
                </Link>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <IndispensabiliDesktop
          desktopBannerWidth={desktopBannerWidth}
          desktopImage={desktopImage}
          desktopTitle={desktopTitle}
          desktopText={desktopText}
          link={link}
          text={text}
          title={title}
          bannerContent={bannerContent}
          itemsAlignment={itemsAlignment}
          marginTop={marginTop}
          marginBottom={marginBottom}
        />
      )}
    </section>
  )
}

export default IndispensabiliNavigation
